var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M2.77.606a4.4 4.4 0 0 1 4.523.038c1.377.862 2.215 2.4 2.207 4.055-.032 1.643-.93 3.189-2.052 4.383a12 12 0 0 1-2.16 1.825.8.8 0 0 1-.261.093.5.5 0 0 1-.252-.077 11.9 11.9 0 0 1-3.11-2.942A6.03 6.03 0 0 1 .5 4.616l.003-.177C.562 2.85 1.416 1.4 2.77.606m2.813 2.652a1.5 1.5 0 0 0-1.667.336 1.6 1.6 0 0 0-.334 1.709c.236.586.794.968 1.413.968.405.003.795-.16 1.082-.454.287-.293.448-.692.446-1.107a1.57 1.57 0 0 0-.94-1.452"
})));
export default SvgIconLocation;